"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jwtService = void 0;
var jwt_decode_1 = require("jwt-decode");
var session_storage_keys_model_1 = require("../../model/session-storage-keys.model");
var JWTService = /** @class */ (function () {
    function JWTService() {
        this.capitaliseName = function (name) {
            return name.toLowerCase().replace(/\b((m)(a?c))?(\w)/g, function ($1, $2, $3, $4, $5) {
                if ($2) {
                    return $3.toUpperCase() + $4 + $5.toUpperCase();
                }
                return $1.toUpperCase();
            });
        };
    }
    JWTService.prototype.getDecodedAccessToken = function () {
        var token = this.getAccessToken();
        return token ? (0, jwt_decode_1.default)(token) : null;
    };
    JWTService.prototype.isAccessTokenExpired = function () {
        var now = Date.now().valueOf() / 1000;
        var decodedToken = this.getDecodedAccessToken();
        if (typeof decodedToken.exp !== 'undefined' && decodedToken.exp < now) {
            return true;
        }
        return false;
    };
    JWTService.prototype.getAccessToken = function () {
        return sessionStorage.getItem(session_storage_keys_model_1.SessionStorageKeys.AccessToken);
    };
    JWTService.prototype.setAccessToken = function (token) {
        sessionStorage.setItem(session_storage_keys_model_1.SessionStorageKeys.AccessToken, token);
    };
    JWTService.prototype.getIdToken = function () {
        return sessionStorage.getItem(session_storage_keys_model_1.SessionStorageKeys.IdToken);
    };
    JWTService.prototype.setIdToken = function (token) {
        sessionStorage.setItem(session_storage_keys_model_1.SessionStorageKeys.IdToken, token);
    };
    JWTService.prototype.getUserNamedId = function () {
        return this.getUserNamedIdFromToken(this.getAccessToken());
    };
    JWTService.prototype.getUserNamedIdFromToken = function (jwt) {
        var decodedToken = !!jwt ? (0, jwt_decode_1.default)(jwt) : null;
        if (decodedToken) {
            return (decodedToken['http://agl.com.au/named_id'] || decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']);
        }
        return null;
    };
    JWTService.prototype.getUserName = function () {
        return this.getUserNameFromToken(this.getAccessToken());
    };
    JWTService.prototype.getUserNameFromToken = function (jwt) {
        var decodedToken = !!jwt ? (0, jwt_decode_1.default)(jwt) : null;
        if (decodedToken) {
            return {
                firstName: "".concat(decodedToken['https://idtoken.agl.com.au/firstname']),
                lastName: "".concat(decodedToken['https://idtoken.agl.com.au/lastname']),
                fullName: "".concat(decodedToken['https://idtoken.agl.com.au/firstname'], " ").concat(decodedToken['https://idtoken.agl.com.au/lastname']),
            };
        }
        return null;
    };
    JWTService.prototype.getFormattedUserName = function () {
        var name = this.getUserName();
        if (name && name.firstName && name.lastName) {
            return {
                firstName: this.capitaliseName("".concat(name.firstName)),
                lastName: this.capitaliseName("".concat(name.lastName)),
                fullName: "".concat(this.capitaliseName(name.fullName)),
            };
        }
        return null;
    };
    return JWTService;
}());
exports.jwtService = new JWTService();
